import { useMyLibraryUrlParams } from '../../_hooks/useMyLibraryUrlParams';

export const PaginationButton: React.FC<{
  type: 'prev' | 'next';
}> = ({ type }) => {
  const { updatePagination } = useMyLibraryUrlParams();
  return (
    <button
      onClick={() => {
        updatePagination(type);
      }}
      className="tw-flex tw-w-[6rem] tw-appearance-none tw-justify-center tw-gap-[0.5rem] tw-rounded-[0.2rem] tw-border-[2px] tw-border-brand-lv1 tw-py-[0.5rem] tw-text-center tw-transition-colors hover:tw-bg-brand-lv3"
    >
      <div className="tw-text-base2 tw-font-bold tw-text-brand-lv1">
        {type === 'next' ? '>' : '<'}
      </div>
      <div className="tw-text-base2 tw-font-bold tw-text-brand-lv1">
        {type === 'next' ? '次へ' : '前へ'}
      </div>
    </button>
  );
};
